import { useI18n } from "@/i18n/I18nContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LABELS = { es: "Español", en: "English", fr: "Français", ru: "Русский" };

export function LanguageSwitcher() {
  const { lang, setLang, langs } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher"
        className="flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-sm font-medium hover:bg-accent"
      >
        <Globe className="h-4 w-4" />
        <span className="uppercase">{lang}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {langs.map((l) => (
          <DropdownMenuItem key={l} data-testid={`lang-option-${l}`} onClick={() => setLang(l)}>
            {LABELS[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
